import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sofb5: FaireReviewEntity = {
  token: "review_sofb5",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "brand",
  reviewerName: "Mindi",
  reviewerLocation: "Brooklandville, MD",
  stars: 5,
  reviewText: "I would highly recommend Softies. They are so easy to deal with and the product is superb!!!",
  reviewDate: "Nov 8, 2021",
  purchasedProductTokens: [
    "p_sfmywzj52b",
  ],
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
